import { Control } from "../../business-objects/control/control.model";
import { CostsControlConfig } from "./costs-control-config.model";

export class CostsControl extends Control {
    config: CostsControlConfig;
}







// WEBPACK FOOTER //
// ./src/vas/controls/costs/costs-control.model.ts